class ExpiredSessionError extends Error {
  constructor(message) {
    super();
    this.message = message;
  }
}

export default ExpiredSessionError;
